import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";

import "ui-components/form-elements/input/wow-input";
import "ui-components/form-elements/switch/switch";
import "../find-collaborators-modal/find-collaborators-modal";

import { styles } from "./co-promotion-toggle.css";
import { SignalElement } from "ui-common/di";
import type { CreatorItem } from "ui-common/services/creator-select/types";
import { translate } from "../../translations/i18n";

@customElement("co-promotion-toggle")
export class CoPromotionToggle extends SignalElement {
  static override styles = [styles];

  @property({ type: Boolean })
  checked = false;

  @property({ type: Array })
  collaboratorHandles: string[] = [];

  @property({ type: Array })
  existingCollaborators: CreatorItem[] = [];

  @state()
  private showModal = false;

  private handleToggle(e: CustomEvent) {
    this.dispatchEvent(
      new CustomEvent("toggle-change", {
        detail: { checked: e.detail.checked },
        bubbles: true,
        composed: true,
      }),
    );
  }

  private handleCollaboratorsSaved(e: CustomEvent) {
    this.dispatchEvent(
      new CustomEvent("collaborators-saved", {
        detail: { collaborators: e.detail.collaborators },
        bubbles: true,
        composed: true,
      }),
    );
    this.showModal = false;
  }

  private handleModalClose() {
    this.showModal = false;
  }

  override render() {
    return html`
      <hr class="section-divider" />
      <div class="toggle-field">
        <wow-switch
          label=${translate("createLiveEventPage.invitePromotionPartners")}
          ?checked=${this.checked}
          @change=${this.handleToggle}
        ></wow-switch>
        ${this.checked
          ? html`
              <div class="co-promotion-search-trigger" @click=${() => (this.showModal = true)}>
                <wow-input placeholder=${translate("findCollaborators.searchPlaceholder")} readonly></wow-input>
              </div>
              ${this.collaboratorHandles.length > 0
                ? html`<div class="selected-collaborators-summary">
                    ${translate("createLiveEventPage.creatorsSelected", {
                      count: String(this.collaboratorHandles.length),
                    })}
                  </div>`
                : nothing}
            `
          : nothing}
      </div>
      ${this.showModal
        ? html`
            <find-collaborators-modal
              .existingCollaborators=${this.existingCollaborators}
              @collaborators-saved=${this.handleCollaboratorsSaved}
              @close=${this.handleModalClose}
            ></find-collaborators-modal>
          `
        : nothing}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "co-promotion-toggle": CoPromotionToggle;
  }
}
